import { attr, belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import JournalEvent from "parog-web/models/journal-event";
import tWithDefault from "parog-web/utils/t-with-default";
import type CnamProcessStartedJournalEvent from "./cnam-process-started-journal-event";

//---- Automatically generated, don't update this part ----

/**
 * This JE is created everytime we start a retrieval for a patient.
 * It helps computing how much tries are left for the hour or for the day.
 */
export default class DmpRetrievalStartedJournalEvent extends JournalEvent {
  static override type = "dmp-retrieval-started-journal-event";

  @attr("string") declare cpsId: string;

  @belongsTo("cnam-process-started-journal-event", {
    async: false,
    inverse: "dmpRetrievalStartedJournalEvent"
  })
  declare cnamProcessStartedJournalEvent: CnamProcessStartedJournalEvent;

  static override validations(intl: IntlService) {
    return {
      cpsId: validatePresence({
        presence: true,
        description: intl.t(
          "validations.dmp-retrieval-started-journal-event.cps-id"
        )
      }),
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.dmp-retrieval-started-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "dmp-retrieval-started-journal-event": DmpRetrievalStartedJournalEvent;
  }
}
